/*
  PDP V2 Style Selector (PDPV2-PILOT).
  Broadcast's <product-modal> binds only the first [data-popup-open] in its holder
  ("Explore more styles"). This forwards the other opener ("More") to it and makes
  focus return to the trigger that was actually used. No other behaviour.
*/
(function () {
  function init(root) {
    if (root.hasAttribute('data-joy-style-ready')) return;
    root.setAttribute('data-joy-style-ready', '');

    var primary = root.querySelector('[data-popup-open]');
    if (!primary) return;

    root.querySelectorAll('[data-joy-styles-open]').forEach(function (trigger) {
      if (trigger === primary) return;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        primary.click();
        if (window.a11y) window.a11y.lastElement = trigger;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-joy-style]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
